// extracted by mini-css-extract-plugin
module.exports = {"parallax":"Page_parallax__1egnH","fixedImage":"Page_fixedImage__26Qgu"};